/* eslint-disable */
export default {
  toolTip: '{crmName}에서 보기',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
